import React, { useEffect, useState } from "react";

import "./App.css";
import "./styles/seims.css";
import "./containers/customLayout.css";

import CustomLayout from "./containers/CustomLayout";
import { useNavigate } from "react-router-dom";
import { logoutInstanceEventListener } from "@seims/shared/src/security";

function App({ failedStart, message }) {
  const [authInit, setAuthInit] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    logoutInstanceEventListener();
    setAuthInit(failedStart);

    if (failedStart) {
      let path = `/autherror`;
      navigate(path, { state: { message: message } });
    }
    // else {
    //   navigate("/");
    // }
  }, [failedStart]);

  return (
    <div className="App">
      <CustomLayout />
    </div>
  );
}

export default App;
